














































import Vue from 'vue';
import Component from 'vue-class-component';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
const AnswerRepository = RepositoryFactory.get('answer');

@Component
export default class InquiryConfirm extends Vue {
  // inquiry_type
  inquiry_type = '';
  // 質問
  inquiries: any[] = [];
  // 回答一覧
  answers: any = {};
  // ページ番号
  page_num = 1;

  // 選択肢
  choices_type7 = [
    { value: '1', label: '1' },
    { value: '2', label: '2' },
    { value: '3', label: '3' },
    { value: '4', label: '4' },
    { value: '5', label: '5' },
    { value: '6', label: '6' },
    { value: '7', label: '7' }
  ];

  choicesType4(inquiry: any): any[] {
    const choices: any[] = [];
    Object.keys(inquiry.selection).forEach(function(index) {
      choices.push({
        value: index,
        label: inquiry.selection[index]
      });
    });

    console.log(choices);

    return choices;
  }

  // 次の画面へ
  async next(): Promise<any> {
    const response = await AnswerRepository.create({
      answers: this.answers
    });

    if (!response) {
      this.toggleLoading({ is_loading: false, time: 1 });
      this.$toasted.error('ネットワークに問題があります', {
        duration: 2000,
        position: 'top-center'
      });
    } else if ('timeout' in response && response.timeout == true) {
      this.$toasted.error('タイムアウトが発生しました', {
        duration: 2000,
        position: 'top-center'
      });
      this.toggleLoading({ is_loading: false, time: 1 });
    } else if (response.status == 200 && response.data.status == 'success') {
      console.log('success');

      this.$router.push('/finish');
    } else if (
      response.status == 400 &&
      response.data.message == 'duplication'
    ) {
      this.toggleLoading({ is_loading: false, time: 1 });
      this.$toasted.error('お客様と回答日時の組がすでに存在しています', {
        duration: 2000,
        position: 'top-center'
      });
    } else if (response.status == 401) {
      this.$toasted.error('ログアウトされています', {
        duration: 2000,
        position: 'top-center'
      });
      this.$store.commit('setUser', null);
      this.$store.commit('setRemember', false);
      this.$store.commit('setLimit', 0);
      this.$store.commit('setApiToken', null);
      this.$store.commit('answer/setAnswers', {});
      this.$router.push('/auth/login');
    } else {
      this.toggleLoading({ is_loading: false, time: 1 });
      console.log('failure');
      this.$toasted.error('処理に失敗しました', {
        duration: 2000,
        position: 'top-center'
      });
    }
  }

  // 修正画面へ
  fix(id: number): void {
    this.$router.push('/inquiry/' + this.inquiry_type + '/' + id + '?fix=1');
  }

  // Loadingの表示，非表示の制御
  toggleLoading(params: { is_loading: boolean; time: number }): void {
    this.$emit('toggleLoading', params);
  }

  async mounted(): Promise<any> {
    this.toggleLoading({ is_loading: true, time: 0 });

    const inquiries = await this.$store.state.question.questions;
    this.inquiries = inquiries[0].questions;
    console.log(this.inquiries);

    this.inquiry_type = this.$route.params.inquiry_type;
    console.log(this.inquiry_type);

    this.answers = this.$store.state.answer.answers;
    console.log(this.answers);

    window.scrollTo(0, 0);
    this.toggleLoading({ is_loading: false, time: 0.5 });
  }
}
